




































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































const fun = (arr: any) => {
  const tmp: any = [];
  const res = arr.map((i: any) => {
    const list = arr
      .filter((l: any) => l.label === i.label)
      .map((l: any) => l.value);
    const r = Object.assign({}, i, {
      valueList: list,
    });
    const indexList = tmp.find((f: any) => f.label === r.label);
    indexList ? null : tmp.push(r);
    return r;
  });
  return tmp;
};
enum PhoneObjectType {
  SELF = 1,
  FIRST_CONTRACT,
  SECOND_CONTRACT,
}
import { Component, Vue, Provide, Watch, Prop } from "vue-property-decorator";
import { Loading } from 'element-ui';
//请求路径
import {
  collectionServiceClient,
  dialerClient,
  ticketClient,
} from "@/api/index";
//请求的参数
import {
  GetRepayReportInfoReq,
  GetPhoneObjectsReq,
  SendSmsByTaskIdReq,
  CasePageTurningReq,
  UpdateCustomerSalaryInfoReq,
  ReduceCreditCardFeeReq,
  UpdateMarketPaymentCodeAmountReq, CreatePaymentLinkReq
} from "@/pbjs/xcommon/collection_pb.js";
import { WASendTextMsgReq } from "@/pbjs/xcommon/ticket_pb.js";
import {
  SmsTaskParamValue,
  SmsTaskParamOption,
} from "@/pbjs/xcommon/core_pb.js";
import { DialReq } from "@/pbjs/xcommon/dialer_pb";
import { getSmsTaskIdMap } from "@/request/smsList";
import {
  localGet,
  timeFormatDay,
  timeFormatSecond,
  timeFormat,
  setMetaData,
  downloadFile,
} from "@/utils/index";
import {API_COUNTRY} from '@/api/root';
const UpdateMarketAmout = () => import("./updateMarketAmout.vue");
const ReducePrincipal = () => import("./reducePrincipal.vue");
const ReducePenalty = () => import("./reducePenalty.vue");
const RolloverTrial = () => import("./RolloverTrial.vue");
const CalenderDate = () => import("@/components/CalenderDate.vue");
const OrderDialogue = () => import("./components/orderDialogue.vue");
const RiskReporting = () => import("./components/riskReporting.vue");
const LoanInfo = () => import("./loanInfo.vue");
const LoanInfoMore = () => import("./loanInfoMore.vue");
const RepaymentIssueReport = () =>
  import("./components/repaymentIssueReport.vue"); // 还款问题上报
import { RollStatus } from "@/pbjs/xcommon/core_pb";
import { setCommon, errorMsg } from "@/utils/request";
import { saveOverdueCaseApi } from "@/request/saveOverdueCase";
import { saveRemindCaseApi } from "@/request/saveRemindCase";
import { GetSmsTaskIdMapReq } from "@/pbjs/xcommon/collection_pb";
import SupplierJson from "@/doc/Supplier.json"; //  lee 自己存储的供应商json
import store from "@/store";
import { WarningLetterStatusEnum } from "@/enum/index";

@Component({
  name: "warn",
  filters: {
    filterTime(time: number) {
      function addZero(val: any) {
        if (val < 10) {
          val = "0" + val;
        }
        return val;
      }
      if (!time) {
        return time;
      }
      let date: any = new Date(time);
      let month: any = addZero(date.getMonth() + 1);
      let day: any = addZero(date.getDate());
      var yearMonthDay = date.getFullYear() + "-" + month + "-" + day;
      var hoursMS =
        addZero(date.getHours()) +
        ":" +
        addZero(date.getMinutes()) +
        ":" +
        addZero(date.getSeconds());
      return yearMonthDay + " " + hoursMS;
    },
  },
  components: {
    UpdateMarketAmout,
    ReducePrincipal,
    ReducePenalty,
    RolloverTrial,
    CalenderDate,
    OrderDialogue,
    RiskReporting,
    LoanInfoMore,
    LoanInfo,
    RepaymentIssueReport,
  },
})
export default class CombinationProperty extends Vue {
  @Provide() private isFailureOptions: any = [
    {
      value: 1,
      name: "v0707.Yes",
    },
    {
      value: 2,
      name: "v0707.No",
    },
  ]; // 是否选项
  @Provide() private nextDialTime: any = "";
  @Provide() private phone: any;
  @Provide() private phoneobject: any;
  @Provide() private robotcalltags: any = [];
  @Provide() private dialogVisibleCard: boolean = false;

  @Prop() private urgebase: any;
  @Provide() private useRepayinfoDetail: number = -1; // 是否使用RepayInfoDetail字段展示：0否，1是
  @Provide() private country: any = localStorage.getItem("country"); // 国家，字段差异化展示
  @Provide() private API_COUNTRY: any = API_COUNTRY; // 国家自定义
  @Provide() private contactFamily: any;
  @Provide() private contactList: any[] = [];
  @Provide() private contactSelfList: any[] = []; // 本人联系方式
  @Provide() private selfContactList: any[] = []; // 本人其他联系方式列表
  @Provide() private ContactTwoContactList: any[] = []; // 联系人二其他联系方式列表
  @Provide() private isSelfContactList: boolean = true; // 本人其他联系方式列表状态
  @Provide() private contactIndiaSmsList: any[] = []; // lee 印度的短信联系人列表，目前只取本人
  @Provide() private warningLetterList: any[] = []; // lee 警告信列表
  @Provide() private isShowLetter: any = true; // lee 警告信列表
  @Provide() private isCouldClick: boolean = false;
  @Provide() private urgeLetterList: Array<object> = [];
  @Provide() private isUrgeLetterListDone: boolean = false; // 是否获取过下载催收函
  @Provide() private noteList: Array<object> = [];
  @Provide() private storeList: Array<object> = [];
  @Provide() private smsparammapMap: Array<object> = [];
  @Provide() private storeParamList: Array<object> = [];
  @Provide() private showStoreSelect: boolean = false; //是否展示便利店选择框
  @Provide() private couponList: Array<object> = []; // 优惠券模板列表
  @Provide() private smsContentMap: any[] = []; // 短信内容数组
  @Provide() private loaninfolistList: any[] = []; // 短信内容数组

  @Provide() private smsContent: any = ""; //短信内容
  @Provide() private WAMessageList: any[] = []; // WA模板列表
  @Provide() private PhoneObjectList: any[] = []; // 联系人列表
  @Provide() private addedPhoneObjectList: any[] = []; // 联系人列表
  @Provide() private PhoneObjectRelationList: any[] = []; // 关系列表
  @Provide() private PhoneObjectMobileMap: any[] = []; // 关系与电话号码列表
  @Provide() private providerOptions: any[] = []; // 匹配供应商映射list
  @Provide() private supplierOptions: any[] = SupplierJson.list; // 匹配供应商映射list
  @Provide() private customerothermobileMap: any[] = []; //
  @Provide() private disableCard: boolean = false;
  @Provide() private showFreezeConfirmCard: boolean = false;
  @Provide() private statusOfApplyForInterestFreezeNum: number = 2;
  @Provide() private disableFreezeBtn: boolean = false;
  @Provide() private addedPhoneObject: any = {
    extcontactdes: "",
    // contactNxSalt: "",
    extrelationship: "",
    extname: "",
  }; // 待增加联系人
  @Provide() private query: any;
  @Provide() private noteValue: any = "";
  @Provide() private noteValueId: any = "";
  @Provide() private storeNameId: any = "";
  @Provide() private urgeLetterId: any = ""; // 催收函id
  @Provide() private couponValueId: any = ""; // 优惠券id
  @Provide() private WAId: any = ""; // WA选中选项
  @Provide() private WAText: any = ""; // WA选中文本
  @Provide() private WACountry: any = ""; // WA需要的国家电话开头码
  @Provide() private language: any = ""; // 语言选中选项
  @Provide() private automaticWAId: any = ""; // WA选中选项
  @Provide() private automaticWACountry: any = ""; // WA需要的国家电话开头码
  @Provide() private automaticWAMessageList: any[] = []; // WA模板列表
  @Provide() private token: any = "";
  @Provide() private lastPromisedRepaymentTime: any = 0; //上次承诺还款时间
  @Provide() private ticketClassify: any = "-"; // 工单类型
  @Provide() private ordertags: any = "-"; // 工单标签
  @Provide() private preorder: any = "-"; // 原始订单号
  @Provide() private customerMobile: any = "----1"; //用户电话
  @Provide() private identity: any = "----1"; // 身份证号码
  @Provide() private customerName: any = ""; //
  @Provide() private customerEmail: any = "----1"; //客户email
  @Provide() private familyMobile: any = ""; //家庭电话
  @Provide() private takephoneResult: any = "----1"; //自动外呼结果
  @Provide() private customerOne: any = {
    //联系人1情况
    mobile: "--1",
    relationship: "--1",
    name: "--1",
  };
  @Provide() private customerTwo: any = {
    //联系人2情况
    mobile: "--1",
    relationship: "--1",
    name: "--1",
  };
  @Provide() private customerThree: any = {
    //联系人3情况
    mobile: "--1",
    relationship: "--1",
    name: "--1",
  };
  @Provide() private noteToObj: any = "0"; //发送短信对象
  @Provide() private whatsappflagMap: any = ""; //发送短信对象
  @Provide() private resRadioList: any = []; //催收结果 联系方式里边
  @Provide() private resRadio: any = 1; //催收结果 联系方式
  @Provide() private resData: any = ""; //催收结果 联系方式 拨打时间
  @Provide() private relationshipmapMap: any[] = []; //催收结果 联系方式 拨打时间
  @Provide() private resCallObj: any = []; // 用户关系列表[[1,父母],[]]
  @Provide() private resCallObjList: any = [""]; //催收结果 联系方式 拨打对象 结果
  @Provide() private reshowCaller: any = ""; //回显拨打对象单选框的关系值
  @Provide() private multi_loan_switch: boolean = false; //判斷是否為循環貸
  @Provide() private resCallObjIndex: any = [
    {
      val: 1,
      index: 0,
    },
    {
      val: 2,
      index: 1,
    },
    {
      val: 3,
      index: 2,
    },
    {
      val: 4,
      index: 4,
    },
    {
      val: 9,
      index: 5,
    },
    {
      val: 10,
      index: 3,
    },
  ]; //催收结果 联系方式 拨打对象 结果
  @Provide() private reshowCallerjPhone: any = ""; //催收结果 联系方式 拨打对象 结果
  @Provide() private resCallResult: any = "1"; //催收结果 电话是否接通
  @Provide() private resCallMain: any = [];
  @Provide() private resCallMainValue: any = ""; //催收结果 还款意愿
  @Provide() private resCalldata: any = ""; //催收结果  承诺还款时间
  @Provide() private resCallamount: any = ""; //催收结果  承诺还款金额
  @Provide() private resOverdue: any = [];
  @Provide() private resOverdueValue: any = ""; //催收结果 逾期原因
  @Provide() private remindResult: any = []; // 催收结果
  @Provide() private remindResult1: any = []; // 催收结果1
  @Provide() private remindResultValue: any = ""; //催收结果 值
  @Provide() private postscriptNote: any = ""; //备注
  @Provide() private vaCode: any = "--"; //va账号
  @Provide() private repaymentSurplus: any = "--"; // 剩余应还
  @Provide() private paymentCode: any = "--"; // 便利店付款码
  @Provide() private paymentCodeMoney: any = "--"; // 还款码金额
  @Provide() private paymentCodeFee: any = "--";
  @Provide() private paymentCodeSecond: any = "--"; // paynet便利店付款码
  @Provide() private paymentCodeMoneySecond: any = "--"; // paynet还款码金额
  @Provide() private paymentCodeFeeSecond: any = "--"; // paynet便利店的手续费
  @Provide() private borrowCode: any = "--"; // 借款订单编号
  @Provide() private repaymentDate: any = "--"; // 应还日期
  @Provide() private repaymentMoney: any = "--"; // 剩余应还金额
  @Provide() private overdueDays: any = "--"; //逾期天数
  @Provide() private extitemList: any = []; //逾期天数
  @Provide() private hasRepaymentMoney: any = "--"; //实还金额
  @Provide() private billAllMoney: any = "--"; //实还金额
  @Provide() private repayInfo: any = {};
  @Provide() private translation: any = {};
  @Provide() private dialId: number = 0;
  @Provide() private itemId: number = 0;
  @Provide() private showDialogType: number = 0;
  @Provide() private issendSmsDone: boolean = false; // 发送短信的loading
  @Provide() private isdownUrgeLetterDone: boolean = false; // 下载催收函的loading
  @Provide() private issendCouponDone: boolean = false; // 发送优惠券的loading
  @Provide() private issendWADone: boolean = false; // 发送WA的loading
  @Provide() private isCouldSendWA: boolean = false; // 是否可以发送WA
  @Provide() private automaticIssendWADone: boolean = false; // 发送WA的loading-自动发送WA
  @Provide() private automaticIsCouldSendWA: boolean = false; // 是否可以发送WA-自动发送WA
  @Provide() private isSaveCaseDone: boolean = false;
  @Provide() private ticketData: any = {};
  @Provide() private isfee: any = "";
  @Provide() private riskreportmapMap: any = [];
  @Provide() private lastphoneconnect: number | null = null; // 最后一次催收是否接通
  @Provide() private repayinclination: number | null = null; // 还款意愿，获取短信接口
  @Provide() private customerId: any = ""; // 客户id
  @Provide() private warningLetterCustomerId: any = ""; // 客户id
  @Provide() private smsrepayday: any = {}; // 客户id
  @Provide() private smsrediskey: any = {}; // 客户id
  @Provide() private caselevel: string = ""; // // 案件等级
  @Provide() private taskcallResult: number = 0; //
  @Provide() private deferPeriodStatus: any = null; // 展期状态
  @Provide() private deferPeriodAmount: number = 0; //展期需还金额
  @Provide() private deferPeriodInfo: any = {}; //展期信息
  @Provide() private PhoneVerifyNote: any = ""; //展期信息
  @Provide() private applyDeferPeriodText: any = "";
  @Provide() private deferPeriodStatusText: any = "";
  @Provide() private isEntrust: number = 0; //是否委外，委外不展示短信功能、电话拨打功能
  @Provide() private userSalaryType: number | null = null; // 用户发薪形式
  @Provide() private userSalaryDayByWeek: number | null = null; // 用户发薪日:周薪/双周薪 展示周一-----周日-----单选，点选
  @Provide() private userSalaryDayByMonth: any = "--"; // 用户发薪日:月薪 展示一个月的日期------时间表
  @Provide() private userSalaryDayByHalfMonth: any = "--"; // 用户发薪日:半月薪 展示一个月的日期------时间表
  @Provide() private userSalaryDayByHalfMonthSecond: any = "--";
  @Provide() private salaryDaysOptions: any = [];
  @Provide() private isShowRoll: boolean = false; // 是否是展期订单
  @Provide() private isShowWarn: boolean = false; // 是否展示
  @Provide() private isShowSelfPhoneCopy: boolean = false; //本人手机号复制按钮是否展示
  @Provide() private isShowOtherPhoneCopy: boolean = false; //联系人手机号复制按钮是否展示
  @Provide() private isShowSend: boolean = false; //WhatsAPP(本人)发送区域是否展示
  @Provide() private isShowContact: boolean = false; //是否展示联系人信息详情页
  @Provide() private isShowSuggest: boolean = false; //建议信息模块是否展示
  @Provide() private suggestData: any = []; //建议信息模块是否展示
  @Provide() private repayinfodetailList: any = []; // 还款信息
  @Provide() private accountName: any = ""; //用户姓名
  @Provide() private isshowcouponmap: any = []; // 是否展示优惠券：1-展示 0-隐藏
  @Provide() private isBadDebts: number = 0; //是否坏账
  @Provide() private orderStatus: any = ""; //订单状态
  @Provide() private suppliertypeList: any = [];
  @Provide() private whatsappVerfiry: any = ''; //逗号分割的字符串 有值即验证通过/无值即不通过
  @Provide() private whatsappNumber: any = ""; //whatsapp号码
  //律师函\
  @Provide() private isYN: boolean = false; //是否是印尼
  @Provide() private selectionList: any = [];
  @Provide() private resultData: any = []; //律师函列表
  @Provide() private lawyerStatusList: any = []; //律师函列表
  @Provide() private sendmethed: any = ["-", "WA", "Email"]; //律师函发送方式列表
  @Provide() private subOrderid: any = ""; //循环贷子订单Orderid
  @Provide() private UrgeLetterEnable: any = ""; //非循环贷是否展示律师函1展示2不展示
  @Provide() private Enable: boolean = true;
  @Provide() private sendLawyertime: string = ""; //律师函发送时间
  @Provide() private urgeresultconnectedmapMap: any = []; //律师函发送时间
  @Provide() private repayReportsStatus: any = null; //上报状态 0 1 2
  @Provide() private env: any = window.location.href;
  @Provide() private DisburseProof: any = '';
  @Provide() private isShowOnepesa: boolean = false; //是否是坦桑尼亚 
  @Provide() private paymentlinkList: any = [];
  @Provide() private showpaymentlink: boolean = false;
  @Provide() private countryCodeNew: any = '';
  // CalllogList
  @Provide() private CalllogList: any = [];
  @Provide() private paymentlinkValue: any = '';
  @Provide() private ordertagsMap: any = '';
  //显示电子钱包/手机号
  @Provide() private curEwallet: any = {};
  @Provide() private historyEwallet: any = [];
  @Provide() private amountLeftCanReduce: any = null; // 可减免金额


  get statusOfApplyForInterestFreeze() {
    return {
      0: this.$t("dashbordDy.unknownFreezeStatus"),
      1: this.$t("dashbordDy.canApplyForInterestFreeze"),
      2: this.$t("dashbordDy.cannotApplyForInterestFreeze"),
      3: this.$t("dashbordDy.interestFreezeing"),
    };
  }

  get disableApplyForInterestFreezeBtn() {
    if (this.disableFreezeBtn || this.statusOfApplyForInterestFreezeNum !== 1) {
      return true;
    }
    return false;
  }

  get taskTarget() {
    let _return = "";
    if (this.query.type === "overdue") {
      _return = "urge";
    } else if (this.query.type === "repay") {
      _return = "remind";
    }
    return _return;
  }
  // WA模板列表
  get languageList() {
    let list: any = [];
    let country = localGet("country");
    if (country == "in") {
      list = [
        {
          label: "English",
          value: "en-US",
        },
        {
          label: "India",
          value: "en-IN",
        },
      ];
    } else if (country == "co" || country == "mx") {
      list = [
        {
          label: "española",
          value: "es-CO",
        },
      ];
    } else if (country == "en") {
      list = [
        {
          label: "English",
          value: "en-US",
        },
      ];
    }
    return list;
  }

  @Watch("userSalaryType")
  onUserSalaryTypeChanged(val: number | null) {
    if (val === 3 || val === 4) {
      this.showDiffTypeDialog(0);
    }
  }

  // 更新便利店还款码
  private async getCode() {
     let request:any = new UpdateMarketPaymentCodeAmountReq();
        request.setCommonin(setCommon());
        request.setOrderid(""+this.query.orderId);
        request.setAmount(this.repaymentSurplus);
        request.setFee(0);
        // request.setAppname(this.repayInfo.loaninfo.appname);
        request.setAppname(this.ticketData.appname)
        collectionServiceClient.updateMarketPaymentCodeAmount(request, {}, (err: any, response:any) => {
            if (response) {
                const data: any = response.toObject();
                if(data.commonout) {
                    if (!data.commonout || (data.commonout.code == 0)) {
                        this.$message({type: "success", message: "成功"});
                        this.refreshPageType();
                    } else if (data.commonout.code == 102) {
                    } else {
                        this.$message.error(data.commonout.errmsg);
                    }
                }else{
                    if (data.code == 0) {
                        this.$message({type: "success", message: "成功"});
                        this.refreshPageType();
                    } else if (data.code == 102) {
                    } else {
                        this.$message.error(data.errmsg);
                    }
                }

            }
            if (err) {
                errorMsg(err);
            }
        })
  }
  // 获取警告信列表
  private async getWarningLetterList() {
    const {
      getWarningLetterListReqRequest,
      getWarningLetterListReq,
    }: any = await import("@/request/warningLetter");
    let res: any = await getWarningLetterListReqRequest.handleHttp(
      getWarningLetterListReq({
        Caseid: +this.query.id,
      }),
      null
    );
    if (res) {
      this.warningLetterList = res.listList.map((item: any, index: number) => {
        switch (item.letterstatus) {
          case WarningLetterStatusEnum.WARNINGLETTERSTATUS_UNSPECIFIED:
            item.statusText = this.$tc("warningLetter.notDownloaded");
            break;
          case WarningLetterStatusEnum.WARNINGLETTERSTATUS_DOWNLOAD:
            item.statusText = this.$tc("warningLetter.alreadyDownloaded");
            break;
          case WarningLetterStatusEnum.WARNINGLETTERSTATUS_SEND:
            item.statusText = this.$tc("warningLetter.alreadySended");
            break;
        }
        item.isClick = false;
        return item;
      });
      this.isShowLetter = res.showletter;
    }
  }
  //  下载警告信列表
  private async downloadWarningLetter(item: any) {
    if (!item.isClick) {
      item.isClick = true;
      const {
        getDownWarningLetterRequest,
        getDownWarningLetterReq,
      }: any = await import("@/request/warningLetter");
      let response: any = await getDownWarningLetterRequest.handleHttp(
        getDownWarningLetterReq({
          Caseid: +this.query.id,
          Id: +item.item.id,
          Accountid: "" + this.warningLetterCustomerId,
        }),
        null
      );
      if (response.mediabody) {
        let bStr = atob(response.mediabody),
          n = bStr.length,
          unit8Array = new Uint8Array(n);
        while (n--) {
          unit8Array[n] = bStr.charCodeAt(n);
        }
        // 下载
        let blob = new Blob([unit8Array], {
          type: "application/pdf",
        });
        downloadFile(blob, "" + this.query.id + ".pdf");
        setTimeout(() => {
          this.getWarningLetterList();
          item.isClick = false;
        }, 40);
      }
    }
  }
  //查询项数字校验
  private inputFuction(e: any, type: string) {
    this.resCallamount = e.replace(/[^\d\.]/g, "");
    if (e[0] == 0 && e.length > 2 && e[1] !== ".") {
      this.resCallamount = "";
    } else {
      let arr: any = [];
      this.resCallamount.split("").forEach((o: any, i: any) => {
        if (o == ".") {
          arr.push(i);
        }
      });
      if (arr.length > 1) {
        this.resCallamount = this.resCallamount.substring(0, arr[1]);
      }
      if (
        this.resCallamount.indexOf(".") !== -1 &&
        this.resCallamount.length - this.resCallamount.indexOf(".") > 3
      ) {
        this.resCallamount = this.resCallamount.substring(
          0,
          this.resCallamount.indexOf(".") + 3
        );
      }
    }
  }
  //  发送警告信列表
  private async sendWarningLetter(item: any) {
    if (item) {
      if (!item.isClick) {
        item.isClick = true;
        const {
          sendWarningLetterRequest,
          getWarningLetterReq,
        }: any = await import("@/request/warningLetter");
        let res: any = await sendWarningLetterRequest.handleHttp(
          getWarningLetterReq({
            Caseid: +this.query.id,
          }),
          null
        );
        if (res) {
          this.getWarningLetterList();
          this.$message.success(this.$tc("warningLetter.sendSuccessfully"));
          setTimeout(() => {
            item.isClick = false;
          }, 40);
        }
      }
    } else {
      this.$message.success(this.$tc("warningLetter.pleaseDownloadFirstly"));
    }
  }
  // 获取律师函列表
  private async getLawyerList() {
    let _arg: any = {
      Page: {
        pageIndex: 1,
        pageSize: 10,
      },
      Customerid: this.customerId,
      Orderid: this.ticketData.orderid,
      UserGroupID: localStorage.getItem("usergroupid"),
      PageType: "detail",
    };

    const {
      getLawyerLetterListReq,
      getLawyerLetterListRequest,
    }: any = await import("@/request/lawyerList");
    let res = await getLawyerLetterListRequest.handleHttp(
      getLawyerLetterListReq(_arg),
      this
    );
    if (res && res.right) {
      this.resultData = res.listList;
      if (res.enable) {
        this.Enable = res.enable == 1 ? false : true;
      }
    } else {
    }
  }
  //发送律师函
  private async sendToLawyer() {
    let _arg: any = {
      Orderid: this.ticketData.orderid,
      Customerid: this.customerId,
      UserGroupID: localStorage.getItem("usergroupid"),
    };
    const { SaveLawyerLetterReq, SaveLawyerLetterRequest }: any = await import(
      "@/request/lawyerList"
    );
    let res = await SaveLawyerLetterRequest.handleHttp(
      SaveLawyerLetterReq(_arg),
      this
    );
    if (res && res.right) {
      this.$message.success("successfully!");
      this.getLawyerList();
    } else {
    }
  }
  //撤回律师函、
  private async changeLawyerStatus(id: number, LetterStatus: number) {
    let _arg: any = {
      id: id,
      LetterStatus: LetterStatus,
      UserGroupID: localStorage.getItem("usergroupid"),
    };
    const {
      changeLawyerLetterReq,
      changeLawyerLetterRequest,
    }: any = await import("@/request/lawyerList");
    let res = await changeLawyerLetterRequest.handleHttp(
      changeLawyerLetterReq(_arg),
      this
    );
    if (res && res.right) {
      this.getLawyerList();
    } else {
    }
  }

  // 切换催收函模板
  private getUrgeLetterOptions(val: any) {
    if (!this.isUrgeLetterListDone) {
      this.getUrgeLetterMap();
      this.isUrgeLetterListDone = true;
    }
  }
  // 获取催收函列表
  private async getUrgeLetterMap() {
    const {
      getUrgeLetterMapReqRequest,
      getUrgeLetterMapReq,
    }: any = await import("@/request/urgeLetter");
    let res: any = await getUrgeLetterMapReqRequest.handleHttp(
      getUrgeLetterMapReq({
        Caselevel: this.caselevel,
        Orderid: this.ticketData.orderid,
      }),
      this
    );
    if (res) {
      this.urgeLetterList = res.urgelettermapMap;
    }
  }
  //  下载催收函pdf
  private async downloadUrgeLetter(item: any, val: any, letter: any) {
    if (item.val === "") {
      this.$message({
        message: this.$tc("ticket.selectWAMessage"),
        type: "error",
      });
      return;
    }
    if (!item.isClick) {
      this.isdownUrgeLetterDone = true;
      item.isClick = true;
      const {
        getDownUrgeLetterRequest,
        getDownUrgeLetterReq,
      }: any = await import("@/request/urgeLetter");
      let response: any = await getDownUrgeLetterRequest.handleHttp(
        getDownUrgeLetterReq(
          this.multi_loan_switch
            ? {
                Letterid: +item.letter, //+this.urgeLetterId,
                Orderid: "" + item.val, //this.ticketData.orderid,
                Extraparams: null,
              }
            : {
                Letterid: +item.val, //+this.urgeLetterId,
                Orderid: "" + this.ticketData.orderid, //this.ticketData.orderid,
                Extraparams: null,
              }
        ),
        null
      );
      if (response.letter) {
        let filename = response.letter.filename ? response.letter.filename : "";
        let bStr = atob(response.letter.data),
          n = bStr.length,
          unit8Array = new Uint8Array(n);
        while (n--) {
          unit8Array[n] = bStr.charCodeAt(n);
        }
        // 下载
        let blob = new Blob([unit8Array], {
          type: "application/pdf",
        });
        this.country === "id"
          ? downloadFile(blob, "" + item.val + ".pdf")
          : downloadFile(blob, "" + filename);
        setTimeout(() => {
          item.isClick = false;
          this.isdownUrgeLetterDone = false;
        }, 40);
      }
    }
  }

  //减免开卡
  private async CreditCardFeeReq() {
    const {
      getReduceCreditCardFeeRequest,
      setReduceCreditCardFeeReq,
    }: any = await import("@/request/ReduceCreditCardFeeReq");
    let res: any = await getReduceCreditCardFeeRequest.handleHttp(
      setReduceCreditCardFeeReq({
        OrderId: this.ticketData.orderid,
        // CardFee:""
      }),
      null
    );
    if (res.commonout.code === 0 || res.code === 0) {
      this.dialogVisibleCard = false;
      this.disableCard = true;
      this.$message({ type: "success", message: "send successfully" });
    }
  }
  // 获取WA列表内容
  private async getWhatsAppMsgMap() {
    const {
      getWhatsAppMsgMapRequest,
      setGetWhatsAppMsgMapReq,
    }: any = await import("@/request/getWhatsAppMsgMap");
    let res: any = await getWhatsAppMsgMapRequest.handleHttp(
      setGetWhatsAppMsgMapReq({
        CaseLevel: this.caselevel,
        lang: this.language,
        OrderId: this.ticketData.orderid,
        appname: this.ticketData.appname,
      }),
      null
    );
    this.WAMessageList =
      res && res.whatsappmsgmapMap ? res.whatsappmsgmapMap : [];
    this.WACountry = res && res.countrycode ? res.countrycode : "";
  }
  // 更改语言选项
  private changeLanguage(value: any) {
    this.resetWAOption();
    this.getWhatsAppMsgMap();
  }
  // 重置WA选项
  private resetWAOption() {
    this.automaticWAId = "";
    this.WAText = "";
  }
  // 更改WA选项
  private changeWAOptions(value: any) {
    this.isCouldSendWA = true;
    this.automaticWAId = "";
    this.WAText = this.WAMessageList.find((item: string[]) => {
      return item[0] === value;
    })[1];
  }
  // 更改WA选项-自动WA消息
  private automaticChangeWAOptions(value: any) {
    this.automaticIsCouldSendWA = true;
    this.WAId = "";
    this.language = "";
    let smscontentMap = this.smsContentMap;
    smscontentMap.forEach((item) => {
      if (item.includes(value)) {
        this.WAText = item[1];
        return;
      }
    });
  }
  // 发送WA
  private sendWAAction() {
    this.isCouldSendWA
      ? this.sendWAFuc()
      : this.$message({
          message: "Pls choose the template",
          type: "warning",
        });
  }
  // 发送WA-自动WA消息
  private automaticSendWAAction() {
    this.automaticIsCouldSendWA
      ? this.automaticSendWAFuc()
      : this.$message({
          message: "Pls choose the template",
          type: "warning",
        });
  }
  private sendWAFuc() {
    let _this = this;
    window.open(
      `https://api.whatsapp.com/send?phone=${_this.WACountry}${
        _this.customerMobile
      }&text=${window.encodeURIComponent(_this.WAText)}`,
      "_blank"
    );
  }
  private automaticSendWAFuc() {
    this.automaticIssendWADone = true;
    const mobile = this.contactSelfList[0]?.contact;
    const urgeType = this.query.type === "repay" ? 1 : 2;
    let request: any = new WASendTextMsgReq();
    request.setCommonin(setCommon());
    request.setMobile(mobile);
    request.setAccountid(this.customerId);
    request.setUrgetype(urgeType);
    request.setTicketid(this.ticketData.id);
    request.setItemid(this.itemId);
    request.setOrderid(this.query.orderId);
    request.setOverduecaseid(this.query.id);
    request.setPhoneobject(PhoneObjectType.SELF);
    request.setWatextmsg(this.WAText);
    // 区分是订单页发消息还是whatapp聊天页发消息
    request.setSource(0);
    ticketClient.wASendTextMsg(
      request,
      setMetaData(),
      (err: any, response: any) => {
        this.automaticIssendWADone = false;
        if (response) {
          const data: any = response.toObject();
          if (data.commonout.code === 0) {
            this.$message.success("Success!");
          } else if (data.commonout.code === 100211) {
            this.$message.error(this.$tc('dashbordDy.notWAUser'))
          } else if (data.commonout.code === 100212) {
            this.$message.error(this.$tc('dashbordDy.notLoginWA'))
          } else if (data.commonout.code === 100213) {
            this.$message.error(this.$tc('dashbordDy.alreadyLoginWA'))
          } else {
            this.$message.error(data.commonout.errmsg);
          }
        }
      }
    );
  }
  // 获取短信列表内容
  private async getSmsTaskIdMap(relationship: any) {
    const { getSmsTaskIdMapRequest, setGetSmsTaskIdMapReq }: any = await import(
      "@/request/getSmsTaskIdMap"
    );
    let res: any = await getSmsTaskIdMapRequest.handleHttp(
      setGetSmsTaskIdMapReq({
        caseLevel: this.caselevel,
        taskcallResult: Number(this.lastphoneconnect),
        repayinclination: Number(this.repayinclination),
        taskTarget: this.taskTarget,
        phoneObject: relationship,
        adminuId: Number(localGet("userid")),
        orderId: this.ticketData.orderid,
        appname: this.ticketData.appname,
      }),
      this
    );
    this.noteList = res.smstaskidmapMap;
    // whatsapp自动发送的模板只取短信的本人模板
    if (relationship === 1) {
      this.automaticWAMessageList = res.smstaskidmapMap;
    }
    this.smsContentMap = res.smscontentmapMap;
    this.smsparammapMap = res.smsparammapMap; //便利店列表
    if (this.smsparammapMap.length < 1) {
      this.showStoreSelect = false;
    }
  }
  // 获取优惠券模板列表内容
  private async getCouponIdMap() {
    let otp = {
      itemid: this.itemId,
      accountid: this.customerId,
      orderid: this.query.orderId,
      appname: this.ticketData.appname,
    };
    const { getCouponTaskIdMap }: any = await import("@/request/getCouponList");
    let res = await getCouponTaskIdMap(otp, this);
    if (res) {
      this.couponList = res.coupontaskidmapMap;
    }
  }
  // 发送优惠券
  private async sendCouponByTaskId() {
    this.issendCouponDone = true;
    let otp = {
      itemid: this.itemId,
      accountid: this.customerId,
      orderid: this.ticketData.orderid,
      couponId: this.couponValueId,
      ticketId: this.ticketData.id,
      appname: this.ticketData.appname,
    };
    
    const { sendCouponId }: any = await import("@/request/getCouponList");
    let res = await sendCouponId(otp, this);
    if (res) {
      this.issendCouponDone = false;
      if (res.commonout.code === 0 || res.code === 0) {
        this.$message({ type: "success", message: "send successfully" });
      }
    }
  }
  // 切换短信模板
  private getSmsOptions(val: any) {
    if (val || val == 0) {
      this.reshowCaller = Number(val);
      if (this.resCallObjList.length) {
        this.reshowCallerjPhone = this.resCallObjList[Number(val)];
      }
    } else {
      this.reshowCaller = 1;
      if (this.resCallObjList.length) {
        this.reshowCallerjPhone = this.resCallObjList[1];
      }
    }
    this.getSmsTaskIdMap(val);
  }
  // 更改电话号码的校验
  private chgPhoneNumber(e: any) {
    !this.testRegNumber(e) &&
      this.$message({
        type: "error",
        message: "added phone have to be number",
      });
  }
  private testRegNumber(val: string) {
    return /^[0-9]+$/.test(val);
  }
  // 更改短信选项
  private noteTemChange(value: any) {
    let smscontentMap = this.smsContentMap;
    this.storeNameId = "";
    for (let i in smscontentMap) {
      let smscontentList = smscontentMap[i];
      if (smscontentList.includes(value)) {
        this.smsContent = smscontentList[1];
      }
    }

    //判断便利店里是否与短信与对应id
    let storeList = this.smsparammapMap;
    for (let j in storeList) {
      let storeContent: any = storeList[j];
      if (storeContent[0] === value) {
        this.storeList = storeContent[1].listList;
        this.showStoreSelect = true;
      } else {
        this.showStoreSelect = false;
      }
    }
  }
  // 更改便利店选项
  private storeChange(value: any) {
    let list = [];
    let obj: any = {
      id: value.id,
      option: [],
    };
    for (let i in value.optionsList) {
      if (value.optionsList[i].id === this.storeNameId) {
        obj.option.push(value.optionsList[i]);
      }
    }
    list.push(obj);
    this.storeParamList = list;
  }
  // 电话拨打时间
  private chgResData(val: any) {
    this.btnIsCouldClicked();
  }
  // 拨打对象
  private callObjChange(value: any) {
    let list = [...this.PhoneObjectMobileMap];
    if (this.customerothermobileMap && this.customerothermobileMap.length) {
      list = [...list, ...this.customerothermobileMap];
    }
    let _val = list.filter((item: any) => {
      return item[0] === value;
    });
    if (list.length && _val && _val.length) {
      this.reshowCallerjPhone = _val[0][1];
    } else {
      this.reshowCallerjPhone = "";
      this.$message({
        type: "error",
        message: "can't match the phone number",
      });
    }
    this.btnIsCouldClicked();
  }
  // 还款意愿
  private callMainChange(value: any) {
    this.btnIsCouldClicked();
  }
  // 承诺还款时间
  private calldataChange(value: any) {
  }
  // 逾期原因
  private overdueChange(value: any) {
    this.btnIsCouldClicked();
  }
  // 催收结果
  private remindResultChange(value: any) {
    this.btnIsCouldClicked();
  }
  private chgresCallResult(val: any) {
    this.btnIsCouldClicked();
  }
  //  保存催收按钮颜色变化
  private btnIsCouldClicked() {
    if (this.country == "id") {
      if (this.resCallResult == 1) {
        if (
          this.remindResultValue &&
          this.resCallMainValue &&
          this.reshowCaller
        ) {
          this.isCouldClick = true;
        } else {
          this.isCouldClick = false;
        }
      } else {
        if (this.remindResultValue && this.reshowCaller) {
          this.isCouldClick = true;
        } else {
          this.isCouldClick = false;
        }
      }
    } else {
      if (this.resCallResult == 1) {
        if (
          this.remindResultValue &&
          this.resCallMainValue &&
          this.reshowCaller &&
          this.resOverdueValue &&
          this.resOverdueValue
        ) {
          this.isCouldClick = true;
        } else {
          this.isCouldClick = false;
        }
      } else {
        if (this.remindResultValue && this.reshowCaller) {
          this.isCouldClick = true;
        } else {
          this.isCouldClick = false;
        }
      }
    }
  }
  private async applyForInterestFreeze() {
    this.disableFreezeBtn = true;
    const {
      setApplyFrozenInterestReq,
      applyFrozenInterestRequest,
    }: any = await import("@/request/ApplyForInterestFreeze");
    let res: any = await applyFrozenInterestRequest.handleHttp(
      setApplyFrozenInterestReq({
        OrderId: this.ticketData.orderid,
      }),
      null
    );
    if (res.commonout.code === 0 || res.code === 0) {
      this.refreshPageType();
      this.$message({ type: "success", message: "freeze successfully" });
    }
    this.showFreezeConfirmCard = false;
    this.disableFreezeBtn = false;
  }
  private showDiffTypeDialog(
    type: number,
    orderid?: any,
    rollDeferPeriodStatus?: any,
    rollinfolistList?: any
  ) {
    this.showDialogType = type;
    this.subOrderid = orderid;
    if (type == 4 && this.multi_loan_switch) {
      // 循环贷展期
      this.deferPeriodInfo = rollinfolistList;
      this.deferPeriodStatus = rollDeferPeriodStatus;
    }
    if (type == 9) {
      this.getRepayReport();
    }
  }
  //获取还款问题上报
  private getRepayReport() {
    let request: any = new GetRepayReportInfoReq();
    request.setCommonin(setCommon());
    request.setOrderid(this.ticketData.orderid);
    collectionServiceClient.getRepayReportInfo(
      request,
      setMetaData(),
      (err: any, response: any) => {
        if (response) {
          let data: any = response.toObject();
          this.repayReportsStatus = data?.repayreportstatus; // 针对上报状态赋值
          if (!data.commonout || data.commonout.code == 0) {
            this.selectionList = data.repaychannelmapMap;
          } else {
            this.$message.error(data.commonout.errmsg);
          }
        }
        if (err) {
          if (err.code == 16) {
            this.$router.push("./login");
          }
        }
      }
    );
  }
  private refreshPageType() {
    if (this.query.type === "overdue") {
      this.getOverdueMsg();
    } else if (this.query.type === "repay") {
      this.getRepaymentMsg();
    }
  }
  // 风险弹窗上报操作i返回值
  private returnRiskReport(value: any) {
    if (value.isShow) {
      this.showDialogType = 0;
    }
  }
  private returnSalaryDateByMonth(item: number) {
    if (this.showDialogType === 5) {
      this.userSalaryDayByHalfMonth = item;
    } else if (this.showDialogType === 6) {
      this.userSalaryDayByHalfMonthSecond = item;
    } else if (this.showDialogType === 7) {
      this.userSalaryDayByMonth = item;
    }
    this.showDiffTypeDialog(0);
  }

  private navCustomer() {
    this.$router.push({
      path: "customerInfo",
      query: {
        id: this.customerId,
      },
    });
  }
  private testUndefined(obj: any, key: any): boolean {
    return obj && obj[key];
  }
  private setresCallObjList(data: any) {
    this.resCallObjList = ["", ...data];
  }
  // 处理公共部分
  private dwCommonFuc(data: any) {
    console.log(data,'===============urgebase==============')
    if (data) {
      this.amountLeftCanReduce = data?.repayplan?.amountleftcanreduce || ''; // 可减免金额
      this.curEwallet = data.accountprofile.currentwallet || {};
      this.historyEwallet = data.accountprofile.historywallets ? data.accountprofile.historywallets?.split(',') : [];
      this.suppliertypeList = data.suppliertypeList;
      this.whatsappVerfiry = data.accountsocials.whatsapp;
      this.ordertagsMap = data.orderdata?.ordertagsMap || [];
      this.whatsappflagMap = data.whatsappflagMap;
      this.urgeresultconnectedmapMap = data.urgeresultconnectedmapMap;
      this.whatsappNumber = data.accountsocials.whatsapp;
      this.robotcalltags = data.robotcalltags
        ? data.robotcalltags.split(",")
        : [];
      if (data.ticketdata) {
        if (this.testUndefined(data.ticketdata, "nexthandletime")) {
          this.lastPromisedRepaymentTime =
            data.ticketdata.nexthandletime &&
            timeFormatSecond(data.ticketdata.nexthandletime);
        }
        this.ticketClassify = data.ticketclassify;
        this.ordertags = data.ordertags;
        this.ticketData = data.ticketdata;
        this.itemId = data.ticketdata.itemid;
        this.isEntrust = data.ticketdata.isentrust;
        if (this.ticketData.isroll === 1) {
          this.isShowRoll = true;
        }
      }
      this.isBadDebts = data.orderdata.isdeaddebt;
      this.orderStatus = data.orderdata.checkstatusshow;
      this.accountName = data.accountbase.realname;
      // 还款信息
      if (data.repayinfo) {
        // 处理多种付款码情况
        // data.repayinfo.repayinfodetailList -> itemList<Array>: value label
        const repayResult = data.repayinfo.repayinfodetailList.map((i: any) => {
          // 将 itemList label相同的值合并为一个数组
          const tmp = fun(i.itemsList || []);
          return Object.assign({}, i, {
            itemsList: tmp,
          });
        });

        this.repayinfodetailList = repayResult;
        this.useRepayinfoDetail = data.repayinfo.userepayinfodetail;
        // 还款信息
        this.vaCode = data.repayinfo.vacode; //va账号
        this.repaymentSurplus = data.repayinfo.leftamount; // 剩余应还
        if (
          data.repayinfo.marketpaymentList &&
          data.repayinfo.marketpaymentList.length > 0
        ) {
          this.paymentCode = data.repayinfo.marketpaymentList[0].paymentcode; // 便利店付款码
          this.paymentCodeMoney = data.repayinfo.marketpaymentList[0].amount; // 还款码金额
          this.paymentCodeFee = data.repayinfo.marketpaymentList[0].fee;

          if (data.repayinfo.marketpaymentList.length > 1) {
            this.paymentCodeSecond =
              data.repayinfo.marketpaymentList[1].paymentcode; // 另一个便利店付款码
            this.paymentCodeMoneySecond =
              data.repayinfo.marketpaymentList[1].amount; // 另一个还款码金额
            this.paymentCodeFeeSecond = data.repayinfo.marketpaymentList[1].fee;
          }
        }
        this.repayInfo = data.repayinfo;
        this.statusOfApplyForInterestFreezeNum = this.repayInfo.frozeninteresttype;
        this.deferPeriodInfo = data.repayinfo.rollinfo;
        this.PhoneVerifyNote = data.repayinfo.phoneverifynote;
        this.deferPeriodStatus =
          data.repayinfo.rollinfo && data.repayinfo.rollinfo.status;
        this.deferPeriodAmount =
          data.repayinfo.rollinfo && data.repayinfo.rollinfo.rollamount;
        if (this.deferPeriodStatus === 1) {
          this.deferPeriodStatusText = this.$t(
            "Extension application status: no extension application"
          );
          this.applyDeferPeriodText = this.$t("Apply for extension");
        } else if (this.deferPeriodStatus === 2) {
          this.deferPeriodStatusText = this.$t(
            "Renewal application status: applying for renewal"
          );
          this.applyDeferPeriodText = this.$t("View exhibition details");
        } else if (this.deferPeriodStatus === 3) {
          this.deferPeriodStatusText = this.$t(
            "Extension application status: Cannot apply for extension"
          );
        }
      }

      if (data.loaninfo) {
        //借款信息
        this.borrowCode = data.loaninfo.orderid;
        this.repaymentDate = timeFormatDay(data.loaninfo.shouldrepaydate);
        this.repaymentMoney = data.loaninfo.leftover;
        this.overdueDays = data.loaninfo.overduedays;
        this.hasRepaymentMoney = data.loaninfo.actualrepayedtotal;
        this.billAllMoney = data.loaninfo.shouldrepayedtotal;
        this.extitemList = data.loaninfo.extitemList;
        this.UrgeLetterEnable = data.loaninfo.urgeletterenable;
        this.DisburseProof = this.repayInfo?.otherdataMap || []
      }
      if (data.loaninfolistList) {
        // 子訂單借款信息，循環貸
        data.loaninfolistList.forEach((item: any, index: any) => {
          item.shouldrepaydate = timeFormatDay(item.shouldrepaydate);
          data.rollinfolistList.forEach((n: any, p: any) => {
            if (index == p) {
              item.rollDeferPeriodStatus = n.status;
              item.rollinfolistList = n;
              if (item.rollDeferPeriodStatus === 1) {
                item.deferPeriodStatusText = this.$t(
                  "Extension application status: no extension application"
                );
                item.applyDeferPeriodText = this.$t("Apply for extension");
              } else if (item.rollDeferPeriodStatus === 2) {
                item.deferPeriodStatusText = this.$t(
                  "Renewal application status: applying for renewal"
                );
                item.applyDeferPeriodText = this.$t("View exhibition details");
              } else if (item.rollDeferPeriodStatus === 3) {
                item.deferPeriodStatusText = this.$t(
                  "Extension application status: Cannot apply for extension"
                );
              }
            }
          });
        });
        this.loaninfolistList = data.loaninfolistList;
      }
      if (data.repayinclinationmapMap) {
        this.resCallMain = data.repayinclinationmapMap;
      }
      if (data.urgeresultmapMap) {
        if (this.country == "id") {
          let urgeresulList: any = [];
          this.remindResult1 = [];
          this.remindResult = [];
          data.urgeresultmapMap.map((item: any, index: any) => {
            this.urgeresultconnectedmapMap.map((em: any, de: any) => {
              if (item[0] == em[0]) {
                this.remindResult1.push(item);
              }
              urgeresulList.push(em[0]);
            });

            if (urgeresulList.indexOf(item[0]) < 0) {

              this.remindResult.push(item);
            }
          });
        } else {
          this.remindResult = data.urgeresultmapMap; // 催收结果
        }
      }
      if (data.notrepayreasonmapMap) {
        this.resOverdue = data.notrepayreasonmapMap;
      }
      this.customerId = data.orderdata && data.orderdata.useraccountid;
      this.preorder =
        data.orderdata && data.orderdata.preorder
          ? data.orderdata.preorder == "0"
            ? "-"
            : data.orderdata.preorder
          : "-";
      this.warningLetterCustomerId =
        data.ticketdata && data.ticketdata.customerid;
      if (data.smsrepayday) {
        this.smsrepayday = data.smsrepayday;
      }
      if (data.smsrediskey) {
        this.smsrediskey = data.smsrediskey;
      }
      if (data.riskreportmapMap) {
        this.riskreportmapMap = data.riskreportmapMap; // 风险原因
      }
      this.lastphoneconnect = data.lastphoneconnect; // 最后一次催收通话，是否接通
      this.repayinclination = data.repayinclination; // 还款意愿
      this.relationshipmapMap = data.relationshipmapMap; // 关系列表
      switch (this.query.type) {
        case "overdue":
          this.getOverdueMsgFuc(data);
          break;
        case "repay":
          this.getRepaymentMsgFuc(data);
          break;
      }
      this.resCallObj = data.relationshipmapMap;
      this.resRadioList = data.communicationwaymapMap;
      // 这里页面初始化请求0的消息列表暂时确定无效删除,如果有问题再加回来
      // this.getSmsOptions(0);
      this.getPhoneObjectRelationList(data); // 获取拨打对象关系Map111
      this.getAddedPhoneObjectList(data); // 获取额外增加的联系人列表
      this.getPhoneobjectmobileMap(data); // 获取联系人电话号码与关系的Map
      this.makeContactList(data); // 在请求结果返回后，创建联系人列表数组信息
      this.makeContactTwoList(data);
      if (localStorage.getItem("country") == "id") {
        this.getLawyerList(); //配置律师函信息
        this.isYN = true;
      }
      // 如果不为空则展示
      if (data.urgestatusmsg) {
        this.isShowWarn = true;
      }
      // 是否展示优惠券：1-展示 0-隐藏
      this.isshowcouponmap = data.isshowcouponmap;
      if (this.isshowcouponmap === 1) {
        this.getCouponIdMap();
      }
    }
  }
  // 获取拨打对象关系Map
  private getPhoneObjectRelationList(data: any) {
    this.PhoneObjectRelationList = data.phoneobjectMap;
  }
  // 获取拨打对象关系手机号码Map
  private getPhoneobjectmobileMap(data: any) {
    this.PhoneObjectMobileMap = data.phoneobjectmobileMap;
  }
  // 获取拨打对象Map
  private getAddedPhoneObjectList(data: any) {
    this.addedPhoneObjectList = data.extcontactList.map((item: any) => {
      item.isAddedPhoneObjectEdited = true;
      let _temp = data.relationshipmapMap.find((itm: any) => {
        return itm[0] === item.extrelationship;
      });

      item.relationshipText = _temp ? _temp[1] : "";
      item.isSaveAddedPerson = false;
      let realNumber = data.phoneobjectmobileMap.find((ar: any) => {
        return item.extcontactobjectid === ar[0];
      });
      item.extcontactNumber = realNumber[1];
      return item;
    });
  }

  // 编辑拨打对象
  private editAddedPerson(obj: any) {
    this.addedPhoneObjectList.forEach((item: any) => {
      item.isAddedPhoneObjectEdited = true;
    });
    obj.isAddedPhoneObjectEdited = false;
  }
  // 取消编辑拨打对象
  private cancelEditAddedPerson(obj: any) {
    obj.isAddedPhoneObjectEdited = true;
  }
  // 清空拨打对象传入参数
  private resetAddedPersonRegExp() {
    this.addedPhoneObject = {
      extcontactdes: "",
      // contactNxSalt: "",
      extrelationship: "",
      extname: "",
    };
  }
  // 判断拨打对象传入参数
  private saveAddedPersonRegExp(obj: any) {
    return Reflect.ownKeys(obj).every((ele: any) => obj[ele]);
  }
  // 保存拨打对象
  private async saveAddedPerson(type: any, item: any) {
    if (this.testRegNumber(item.extcontactdes)) {
      let _arg: any = {
        OrderID: this.ticketData.orderid,
        Contact: item.extcontactdes,
        Relationship: +item.extrelationship,
        Name: item.extname,
        OpUID: +localGet("userid"),
      };
      if (item.extcontactid) {
        _arg.Extcontactid = item.extcontactid;
      }
      if (this.saveAddedPersonRegExp(_arg)) {
        item.isSaveAddedPerson = true;
        const { setSaveContactReq, saveContactReqRequest }: any = await import(
          "@/request/saveContact"
        );
        let data = await saveContactReqRequest.handleHttp(
          setSaveContactReq(_arg),
          this
        );
        item.isSaveAddedPerson = data ? data.loading : false;
        if (data && data.right) {
          this.resetAddedPersonRegExp();
          this.$message({
            type: "success",
            message: "save successfully!",
          });
          this.refreshPageType();
        }
      } else {
        this.$message({
          type: "error",
          message: "you have to input the relation and name",
        });
      }
    } else {
      this.$message({
        type: "error",
        message: "added phone have to be number",
      });
    }
  }
  private getMobileNum(mobile: any) {
    if (mobile) {
      let num = this.PhoneObjectMobileMap.find((item) => {
        return item[1] == mobile;
      });
      if (num) {
        return num[0];
      } else {
        return "--1";
      }
    } else {
      return "--1";
    }
  }
  // 获取联系人的关系[1, "父母"]
  getRelationship(val: any) {
    if (val) {
      let num = this.relationshipmapMap.find((item) => {
        return item[0] == val;
      });
      if (num) {
        return num[1];
      } else {
        return "--1";
      }
    } else {
      return "--1";
    }
  }
  // 创建联系人列表信息
  private makeContactList(data: any) {
    interface IContact {
      contactName: string;
      name: string;
      contact: string;
      type: string;
      relation: number;
      relationship: string;
      email: string;
      facebook?: string;
      contactSalt: string;
      contactNxSalt: string;
      sendSms?: string;
    }
    let person: IContact = {
      contactName: "phone",
      name:
        data.accountbase && data.accountbase.realname
          ? data.accountbase.realname
          : "--1",
      email:
        data.accountbase && data.accountbase.email
          ? data.accountbase.email
          : "--1",
      facebook:
        data.repayinfo && data.repayinfo.creditenhanceinfo
          ? data.repayinfo.creditenhanceinfo.facebook
          : "",
      type: "self",
      relation: this.getMobileNum(data.accountbase && data.accountbase.mobile),
      relationship: "--1",
      sendSms: "sendMessageToCustomer",
      contact:
        data.accountbase && data.accountbase.mobile
          ? data.accountbase.mobile
          : "--1",
      contactSalt:
        data.phoneinfo && data.phoneinfo.mobiledes
          ? data.phoneinfo.mobiledes
          : "--1",
      contactNxSalt:
        data.phoneinfo && data.phoneinfo.mobilenxsalt
          ? data.phoneinfo.mobilenxsalt
          : "--1",
    };
    let person1: IContact = {
      contactName: "phoneTwo",
      name: "",
      email: "",
      facebook: "",
      type: "self",
      relation: this.getMobileNum(
        data.repayinfo &&
          data.repayinfo.creditenhanceinfo &&
          data.repayinfo.creditenhanceinfo.secondmobile
      ),
      relationship: "--1",
      sendSms: "sendMessageToCustomer2",
      contact:
        data.repayinfo &&
        data.repayinfo.creditenhanceinfo &&
        data.repayinfo.creditenhanceinfo.secondmobile
          ? data.repayinfo.creditenhanceinfo.secondmobile
          : "--1",
      contactSalt:
        data.phoneinfo && data.phoneinfo.secondmobiledes
          ? data.phoneinfo.secondmobiledes
          : "--1",
      contactNxSalt:
        data.phoneinfo && data.phoneinfo.secondmobilenxsalt
          ? data.phoneinfo.secondmobilenxsalt
          : "--1",
    };
    let contactOne: IContact = {
      contactName: "contact1phone",
      name:
        data.accountprofile && data.accountprofile.contact1name
          ? data.accountprofile.contact1name
          : "--1",
      email: "",
      type: "customerOne",
      relation: this.getMobileNum(
        data.accountprofile && data.accountprofile.contact1
      ),
      relationship: this.getRelationship(
        data.accountprofile && data.accountprofile.relationship1
      ),
      sendSms: "sendMessageToContactOne",
      contact:
        data.accountprofile && data.accountprofile.contact1
          ? data.accountprofile.contact1
          : "--1",
      contactNxSalt:
        data.phoneinfo && data.phoneinfo.contact1nxsalt
          ? data.phoneinfo.contact1nxsalt
          : "--1",
      contactSalt:
        data.phoneinfo && data.phoneinfo.contact1des
          ? data.phoneinfo.contact1des
          : "--1",
    };
    let contactTwo: IContact = {
      contactName: "contact2phone",
      name:
        data.accountprofile && data.accountprofile.contact2name
          ? data.accountprofile.contact2name
          : "--1",
      email: "",
      type: "customerTwo",
      relation: this.getMobileNum(
        data.accountprofile && data.accountprofile.contact2
      ),
      relationship: this.getRelationship(
        data.accountprofile && data.accountprofile.relationship2
      ),
      sendSms: "sendMessageToContactTwo",
      contact:
        data.accountprofile && data.accountprofile.contact2
          ? data.accountprofile.contact2
          : "--1",
      contactNxSalt:
        data.phoneinfo && data.phoneinfo.contact2nxsalt
          ? data.phoneinfo.contact2nxsalt
          : "--1",
      contactSalt:
        data.phoneinfo && data.phoneinfo.contact2des
          ? data.phoneinfo.contact2des
          : "--1",
    };
    let contactThree: IContact = {
      contactName: "contact3phone",
      name:
        data.accountprofile && data.accountprofile.contact3name
          ? data.accountprofile.contact3name
          : "--1",
      email: "",
      type: "customerThree",
      relation: this.getMobileNum(
        data.accountprofile && data.accountprofile.contact3
      ),
      relationship: this.getRelationship(
        data.accountprofile && data.accountprofile.relationship3
      ),
      sendSms: "sendMessageToContactThree",
      contact:
        data.accountprofile && data.accountprofile.contact3
          ? data.accountprofile.contact3
          : "--1",
      contactNxSalt:
        data.phoneinfo && data.phoneinfo.contact3nxsalt
          ? data.phoneinfo.contact3nxsalt
          : "--1",
      contactSalt:
        data.phoneinfo && data.phoneinfo.contact3des
          ? data.phoneinfo.contact3des
          : "--1",
    };

    let contactFamily: IContact = {
      contactName: "familyphone",
      name: "familyphone",
      email: "",
      type: "familyphone",
      relation: this.getMobileNum(
        data.accountprofile && data.accountprofile.familyphone
      ),
      relationship: this.getRelationship(
        data.accountprofile && data.accountprofile.relationship3
      ),
      sendSms: "familyphone",
      contact:
        data.accountprofile && data.accountprofile.familyphone
          ? data.accountprofile.familyphone
          : "--1",
      contactNxSalt:
        data.phoneinfo && data.phoneinfo.familynxsalt
          ? data.phoneinfo.familynxsalt
          : "--1",
      contactSalt:
        data.phoneinfo && data.phoneinfo.familydes
          ? data.phoneinfo.familydes
          : "--1",
    };
    this.contactFamily = contactFamily;

    let newContactList =
      this.query.type === "repay"
        ? this.country === "vn" ||
          this.country === "co" ||
          this.country === "id" // 印尼和越南和哥伦比亚的还款提醒打开其他联系人
          ? [person, person1, contactOne, contactTwo, contactThree]
          : [person, person1]
        : [person, person1, contactOne, contactTwo, contactThree];
    // 本人其他联系电话号码列表
    this.selfContactList = [];
    if (data.customerothermobileMap && data.customerothermobileMap.length) {
      this.customerothermobileMap = data.customerothermobileMap;
      data.customerothermobileMap.forEach((item: any) => {
        let _obj = {
          contactName: "phone",
          contact: item[1],
          contactSalt: item[1],
          contactNxSalt: item[1],
          relation: item[0],
        };
        this.selfContactList.push(_obj);
      });
    }
    if (this.country === "vn") {
      this.isSelfContactList = Boolean(data.havecustomerothermobile);
    } else {
      this.isSelfContactList = false;
    }
    this.contactList = newContactList.filter((items: any) => {
      return items.contact != "--1";
    });
    this.contactIndiaSmsList = [person];
    this.contactSelfList = [person];
    // 这里默认选中本人模板
    if (person) {
      this.noteToObj = person.relation;
      this.getSmsOptions(person.relation);
    }
  }
  // 创建联系人二的其他联系方式的列表
  private makeContactTwoList(data: any) {
    if(data.accountprofile && data.accountprofile) {
      if(data.accountprofile.concatMap?.length > 0) {
        this.ContactTwoContactList = data.accountprofile.concatMap;
      }
    }
    this.CalllogList = data?.accountprofile?.calllogsList || []
  }
  // 獲取催收數據
  private getOverdueMsgFuc(data: any) {
    if (data) {
      // this.makeContactList(data); // 在请求结果返回后，创建联系人列表数组信息
      let _list = [];
      // 是否隐藏whatsapp，1-隐藏，0-显示
      this.isShowSend = data.ishidewhatsapp === 0 ? true : false;
      // 是否隐藏联系人，1-隐藏，0-显示
      this.isShowContact = data.ishiddencontact === 0 ? true : false;
      // 是否隐藏隐藏建议信息模块，2-隐藏，1-显示 0-未定义（默认隐藏）
      this.isShowSuggest = data.showsuggest === 1 ? true : false;
      // 建议信息模块list
      this.suggestData = data.showsuggest === 1 ? data.suggest.suggestitemList : [];
      // 是否可以复制本人手机号
      this.isShowSelfPhoneCopy = data.nocopymobileself === 1 ? false : true;
      //是否可以复制联系人手机号
      this.isShowOtherPhoneCopy = data.nocopymobilecontact === 1 ? false : true;

      if (data.accountbase) {
        this.identity = data.accountbase.identity;
        this.customerMobile = data.accountbase.mobile;
        this.customerName = data.accountbase.realname;
        this.customerEmail = data.accountbase.email;
        _list.push(data.accountbase.mobile);
      }
      if (data.accountprofile) {
        this.customerOne.mobile = data.accountprofile.contact1;
        // this.customerOne.relationship = data.accountprofile.relationship1;
        this.customerOne.name = data.accountprofile.contact1name;
        _list.push(data.accountprofile.contact1);
        this.customerTwo.mobile = data.accountprofile.contact2;
        // this.customerTwo.relationship = data.accountprofile.relationship2;
        this.customerTwo.name = data.accountprofile.contact2name;
        _list.push(data.accountprofile.contact2);
        this.customerThree.mobile = data.accountprofile.contact3;
        // this.customerTwo.relationship = data.accountprofile.relationship2;
        this.customerThree.name = data.accountprofile.contact3name;
        _list.push(data.accountprofile.contact3);
        this.familyMobile = data.accountprofile.familyphone;
        _list.push(data.accountprofile.familyphone);
        //  匹配联系人关系
        if (data.relationshipmapMap && data.relationshipmapMap.length > 0) {
          for (let item of data.relationshipmapMap) {
            if (item[0] == data.accountprofile.relationship1) {
              this.customerOne.relationship = item[1];
            }
            if (item[0] == data.accountprofile.relationship2) {
              this.customerTwo.relationship = item[1];
            }
            if (item[0] == data.accountprofile.relationship3) {
              this.customerThree.relationship = item[1];
            }
          }
        }
        if (data.accountprofile.salarytype) {
          this.userSalaryType = data.accountprofile.salarytype;
          if (data.accountprofile.salaryday) {
            if (this.userSalaryType === 1) {
              let arr: string[] = data.accountprofile.salaryday.split(",");
              this.userSalaryDayByHalfMonth = arr[0];
              this.userSalaryDayByHalfMonthSecond = arr[1];
            } else if (this.userSalaryType === 2) {
              this.userSalaryDayByMonth = data.accountprofile.salaryday;
            } else if (this.userSalaryType === 3 || this.userSalaryType === 4) {
              this.userSalaryDayByWeek = data.accountprofile.salaryday;
            }
          }
        }
      }
      this.setresCallObjList(_list); //保存电话列表
      if (data.autocallresult) {
        this.takephoneResult =
          data.autocallresult.result.callstarttime > 0
            ? `${timeFormatSecond(data.autocallresult.result.callstarttime)}--${
                data.autocallresult.result.duration
                  ? this.$tc("ticket.Connect")
                  : this.$tc("ticket.NotConnected")
              }`
            : `${
                data.autocallresult.result.duration
                  ? this.$tc("ticket.Connect")
                  : this.$tc("ticket.NotConnected")
              }`;
        this.taskcallResult = data.autocallresult.result.duration > 0 ? 1 : 0; // 呼叫结果
      }
      if (data.urgecase) {
        this.caselevel = data.urgecase.caselevel; // 案件等级
      }
      this.getWhatsAppMsgMap();
      this.country === "id" && this.getWarningLetterList();
    }
  }
  private async getOverdueMsg() {
    const { setGetOverdueCaseReq, getOverdueCaseRequest }: any = await import(
      "@/request/getOverdueCase"
    );
    let data = await getOverdueCaseRequest.handleHttp(
      setGetOverdueCaseReq({
        caseId: Number(this.query.id),
      }),
      this
    );
    this.dwCommonFuc(data.urgebase);
  }
  // 獲取提醒數據
  private getRepaymentMsgFuc(data: any) {
    if (data) {
      let _mobilelist = [];
      // 是否隐藏whatsapp，1-隐藏，0-显示
      this.isShowSend = data.ishidewhatsapp === 0 ? true : false;
      // 是否隐藏联系人，1-隐藏，0-显示
      this.isShowContact = data.ishiddencontact === 0 ? true : false;
      // 是否可以复制本人手机号
      this.isShowSelfPhoneCopy = data.nocopymobileself === 1 ? false : true;
      //是否可以复制联系人手机号
      this.isShowOtherPhoneCopy = data.nocopymobilecontact === 1 ? false : true;
      // 是否隐藏隐藏建议信息模块，2-隐藏，1-显示 0-未定义（默认隐藏）
      this.isShowSuggest = data.showsuggest === 1 ? true : false;
      // 建议信息模块list
      this.suggestData = data.showsuggest === 1 ? data.suggest.suggestitemList : [];
      if (data.accountbase) {
        this.identity = data.accountbase.identity;
        this.customerMobile = data.accountbase.mobile;
        this.customerName = data.accountbase.realname;
        this.customerEmail = data.accountbase.email;
        _mobilelist.push(data.accountbase.mobile);
      }
      if (data.accountprofile) {
        this.customerOne.mobile = data.accountprofile.contact1;
        this.customerOne.relationship = data.accountprofile.relationship1;
        this.customerOne.name = data.accountprofile.contact1name;
        _mobilelist.push(data.accountprofile.contact1);
        this.customerTwo.mobile = data.accountprofile.contact2;
        this.customerTwo.relationship = data.accountprofile.relationship2;
        this.customerTwo.name = data.accountprofile.contact2name;
        _mobilelist.push(data.accountprofile.contact2);
        this.customerThree.mobile = data.accountprofile.contact3;
        this.customerThree.relationship = data.accountprofile.relationship3;
        this.customerThree.name = data.accountprofile.contact3name;
        _mobilelist.push(data.accountprofile.contact3);
        this.familyMobile = data.accountprofile.familyphone;
        _mobilelist.push(data.accountprofile.familyphone);
        if (data.accountprofile.salarytype) {
          this.userSalaryType = data.accountprofile.salarytype;
          if (data.accountprofile.salaryday) {
            if (this.userSalaryType === 1) {
              let arr: string[] = data.accountprofile.salaryday.split(",");
              this.userSalaryDayByHalfMonth = arr[0];
              this.userSalaryDayByHalfMonthSecond = arr[1];
            } else if (this.userSalaryType === 2) {
              this.userSalaryDayByMonth = data.accountprofile.salaryday;
            } else if (this.userSalaryType === 3 || this.userSalaryType === 4) {
              this.userSalaryDayByWeek = data.accountprofile.salaryday;
            }
          }
        }
      }
      this.setresCallObjList(_mobilelist); //保存电话列表
      if (data.urgeresultmapMap) {
        if (this.country == "id") {
          let urgeresulList: any = [];
          this.remindResult1 = [];
          this.remindResult = [];
          data.urgeresultmapMap.map((item: any, index: any) => {
            this.urgeresultconnectedmapMap.map((em: any, de: any) => {
              if (item[0] == em[0]) {
                this.remindResult1.push(item);
              }
              urgeresulList.push(em[0]);
            });

            if (urgeresulList.indexOf(item[0]) < 0) {

              this.remindResult.push(item);
            }
          });
        } else {
          this.remindResult = data.urgeresultmapMap; // 催收结果
        }
      }
      if (data.remindcase) {
        this.caselevel = data.remindcase.level; // 案件等级
      }
      if (data.autocallresult.result) {
        this.takephoneResult =
          data.autocallresult.result.callstarttime > 0
            ? `${timeFormatSecond(data.autocallresult.result.callstarttime)}--${
                data.autocallresult.result.duration
                  ? this.$tc("ticket.Connect")
                  : this.$tc("ticket.NotConnected")
              }`
            : `${
                data.autocallresult.result.duration
                  ? this.$tc("ticket.Connect")
                  : this.$tc("ticket.NotConnected")
              }`;
        this.taskcallResult = data.autocallresult.result.duration > 0 ? 1 : 0; // 呼叫结果
      }
      this.getWhatsAppMsgMap();
    }
  }
  private async getRepaymentMsg() {
    const { setGetRemindCaseReq, getRemindCaseRequest }: any = await import(
      "@/request/getRemindCase"
    );
    let data = await getRemindCaseRequest.handleHttp(
      setGetRemindCaseReq({
        caseId: Number(this.query.id),
      }),
      this
    );
    this.dwCommonFuc(data.urgebase);
  }
  private onCopy(e: any) {
    // e.text
    this.$message.success("copy success");
  }
  private onError(e: any) {
    this.$message.success("copy failed");
  }
  // 打電話

  private dwMakeDialogFuc(
    phone: string | number,
    supplier: number,
    relation: number
  ) {
    return {
      assignuId: this.ticketData.assignuid,
      phoneNumber: phone + "",
      supplier: supplier,
      orderId: this.ticketData.orderid,
      ticketType: this.ticketData.itemid,
      ticketId: this.ticketData.id,
      opuId: Number(localGet("userid")),
    };
  }
  // 打電話
  private async makeDialog(
    phone: string | number,
    supplier: number,
    relation: number
  ) {
    this.$emit("makeDialogueAction", {
      reshowCaller: relation, // 关系
      reshowCallerjPhone: phone, // 拨打号码
      phoneTime: timeFormat(new Date().getTime()), // 默认拨打时间  yyyy-MM-dd HH:mm:ss
      communicationWay: "1",
    });
    this.makeDialogueAction({
      reshowCaller: relation, // 关系
      reshowCallerjPhone: phone, // 拨打号码
      phoneTime: timeFormat(new Date().getTime()), // 默认拨打时间  yyyy-MM-dd HH:mm:ss
      communicationWay: "1",
    });
    const { makeDial }: any = await import("@/request/makeDial");
    let res = await makeDial(
      this.dwMakeDialogFuc(phone, supplier, relation),
      this
    );
    if (res) {
      this.dialId = res.dialid;
    }
  }
  private makeDialogueAction(res: any) {
    this.reshowCaller = res.reshowCaller; // 回显拨打对象
    this.reshowCallerjPhone = res.reshowCallerjPhone; // 回显拨打对象
    this.resData = res.phoneTime; // 默认拨打时间  yyyy-MM-dd HH:mm:ss
    this.resRadio = Number(res.communicationWay);
  }
  private makeDialogueResult(res: any) {
    this.dialId = res.dialid;
  }
  private getCustomerOtherMobileAction(args: any) {
    this.refreshPageType();
    this.isSelfContactList = true;
  }
  // 发送短信
  private sendSmsByTaskId() {
    if (this.showStoreSelect && this.storeNameId === "") {
      this.$message({
        message: this.$tc("ticketWrh.selectStore"),
        type: "error",
      });
      return;
    }
    this.issendSmsDone = true;
    let phoneObj: number | null = null; //1:本人 2:联系人1 3:联系人2
    let mobile: string = "";
    switch ("" + this.noteToObj) {
      case "0":
        mobile = this.customerMobile;
        phoneObj = 1;
        break;
      case "1":
        mobile = this.customerMobile;
        phoneObj = 1;
        break;
      case "2":
        mobile = this.customerOne.mobile;
        phoneObj = 2;
        break;
      case "3":
        mobile = this.customerTwo.mobile;
        phoneObj = 3;
        break;
      case "4":
        mobile = this.customerThree.mobile;
        phoneObj = 4;
      case "30":
        mobile = this.customerThree.mobile;
        phoneObj = 30;
    }
    let map: any = new Map(JSON.parse(JSON.stringify(this.noteList)));
    let storeParam: any = new Map(JSON.parse(JSON.stringify(this.storeList)));

    let _arr: any[] = [];
    let option: any[] = [];
    this.storeParamList.forEach((item: any) => {
      let requestAuto: any = new SmsTaskParamOption();
      requestAuto.setId(+item.option[0].id);
      requestAuto.setName(item.option[0].name);
      let requestValue: any = new SmsTaskParamValue();
      requestValue.setParamid(+item.id);
      requestValue.setOption(requestAuto);
      option.push(requestValue);
    });

    let request: any = new SendSmsByTaskIdReq();
    request.setCommonin(setCommon());
    request.setMobile(mobile);
    request.setTaskid(Number(this.noteValueId)); // 下拉短信id，number
    request.setRepayday(this.smsrepayday); // 返回的
    request.setRediskey(this.smsrediskey); // 返回的
    request.setRepaymd(this.smsrepayday);
    request.setOverdueday(this.overdueDays);
    request.setAccountid(this.customerId); // 客户id
    request.setSmstemplate(map.get(this.noteValueId)); // 下拉短信模板值
    request.setOrderid(this.ticketData.orderid);
    request.setOverduecaseid(Number(this.query.id));
    request.setPhoneobject(phoneObj);
    let _num = this.query.type === "repay" ? 1 : 2;
    request.setItemid(Number(this.ticketData.itemid));
    request.setTicketid(Number(this.ticketData.id));
    request.setUrgetype(Number(_num));
    request.setAppname(this.ticketData.appname);
    //增加参数
    request.setParamlistList(option);
    collectionServiceClient.sendSmsByTaskId(
      request,
      setMetaData(),
      (err: any, response: any) => {
        if (response) {
          const data: any = response.toObject();
          if (!data.commonout || data.commonout.code == 0) {
            this.$message({ type: "success", message: "send successfully" });
            this.$emit("getTableData", true);
          } else if (data.code == 100100 || data.code == 100101) {
            this.$router.push("./login");
          } else if (data.commonout.code == 102) {
          } else {
            this.$message.error(data.commonout.errmsg);
          }
        }
        if (err) {
          errorMsg(err);
        }
        this.issendSmsDone = false;
      }
    );
  }
  // 保存催收记录
  private saveCase() {
    if (this.query.type === "overdue") {
      this.isSaveCaseDone = true;
      this.saveOverdueCase();
    } else if (this.query.type === "repay") {
      this.isSaveCaseDone = true;
      this.saveRemindCase();
    }
  }

  // 清空提交的表单的值
  private resetSaveForm() {
    this.isCouldClick = false;
    this.remindResultValue = "";
    this.postscriptNote = "";
    if (this.resCallResult == 1) {
      this.resCallMainValue = "";
      this.resOverdueValue = "";
    }
    this.resCallResult = "1";
    this.reshowCaller = "";
    this.resRadio = 1;
    this.resCalldata = "";
    this.resCallamount = "";
    this.resData = "";
  }
  private testSaving() {
    if (this.isCouldClick && this.query.id && this.ticketData.orderid) {
      const temp = this.resData
        ? new Date(this.resData).getTime()
        : new Date().getTime();
      if (!this.resData) {
        this.resData = timeFormat(new Date().getTime());
      }
      if (this.resCallResult == 1 && this.resCallMainValue == 1) {
        if (new Date(this.resCalldata).getTime() > temp) {
          return true;
        } else {
          this.$message({
            type: "error",
            message: this.$tc("PTP is incorrect, please fill in again"),
          });
          return false;
        }
      } else {
        return true;
      }
    }
    return false;
  }
  // 判断是否获得电话号码
  private whetherPhoneReady() {
    if (this.reshowCallerjPhone && this.reshowCallerjPhone !== "--1") {
      return this.reshowCallerjPhone;
    }
    return 0;
  }
  // 保存催收记录
  private async saveOverdueCase() {
    // string Result = 1; // 结果
    // string Remark = 2; // 备注
    // int64 CaseId = 3; // 案件ID
    // int64 TotalRiskReport = 4; // 风险上报
    // int64 OrderId = 5 [jstype = JS_STRING];
    // int32 PhoneConnected = 6; // 是否接通
    // int32 RepayInclination = 7; // 还款意愿
    // int32 PhoneUnconnectReason = 8; // 未接通原因
    // int32 PhoneObject = 9; // 拨打对象
    // string PhoneCallInput = 10; // 拨打对象手机号
    // int32 ReasonItem = 11; // 逾期、未还款原因
    // int32 CommunicationWay = 12; // 沟通方式
    // string CommunicationWayRemark = 13; // 联系方式选择others时，备注其它联系方式
    // string PromiseRepayTime = 14; // 承诺还款时间
    // string PhoneTime = 15; // 拨打时间
    // int64 CallId = 16 [jstype = JS_STRING]; // 拨打记录ID
    if (this.resCalldata && timeFormat(this.nextDialTime)) {
      this.$message({
        type: "error",
        message: this.$tc("tipsLgy.NotPTPAndNextCallTime"),
      });
      this.isSaveCaseDone = false;
      return;
    }
    if (this.testSaving()) {
      const map: any = new Map(this.remindResult);
      const map1: any = new Map(this.remindResult1);

      let _arg: any = {
        Result:
          this.country == "id" && this.resCallResult == 1
            ? map1.get(this.remindResultValue)
            : map.get(this.remindResultValue), // 结果
        Caseid: this.query.id, // 案件ID
        Orderid: this.ticketData.orderid, // int64 OrderId = 5 [jstype = JS_STRING];
        Phoneobject: this.phoneobject || this.reshowCaller, // 拨打对象
        // Phonecallinput: "" + ,// 拨打对象手机号
        Phoneconnected: Number(this.resCallResult), // 是否接通
        Reasonitem: this.remindResultValue, // 逾期、未还款原因
        Communicationway: Number(this.resRadio), // 沟通方式
        Callid: "" + this.dialId, // int64 CallId = 16 [jstype = JS_STRING]; // 拨打记录ID
        Itemid: this.itemId,
        Phonetime: this.resData, // 拨打时间
        nextDialTime: timeFormat(this.nextDialTime), // dialer下次拨打时间
      };
      if (this.whetherPhoneReady()) {
        _arg.Phonecallinput = this.whetherPhoneReady();
      }
      if (this.resCallResult == 1) {
        _arg.Repayinclination = this.resCallMainValue; // 还款意愿
        _arg.Phoneunconnectreason = this.resOverdueValue; // 未接通原因
      }
      if (this.resCallMainValue == 1) {
        _arg.Promiserepaytime = this.resCalldata; // 承诺还款时间
        _arg.Promiserepayamount =
          this.resCallamount == 0 ? 0 : this.resCallamount; // 承诺还款时间
      }
      if (this.postscriptNote) {
        _arg.Remark = this.postscriptNote; // 备注
      }
      let res = await saveOverdueCaseApi(_arg, this);
      if (res.commonout && res.commonout.code == 0) {
        this.nextDialTime = "";
        this.$message({ type: "success", message: "save successfully" });
        this.resetSaveForm();
        this.$emit("getTableData", true);
        // this.getSmsOptions(0); // 保存催收记录，应印度需求重新获取短信模板
        //保存催收之后，对应短信模板会改变，需清空所选短信模板与对应的便利店名称
        this.noteValueId = "";
        this.storeNameId = "";
        this.$route.query.phoneobject && this.callInfo();
        this.refreshPageType();
      }
    }
    this.isSaveCaseDone = false;
  }
  // 呼叫当前信息
  private async callInfo() {
    const { dialerCurrentInfo }: any = await import("@/request/autoDial");
    let res = await dialerCurrentInfo();
    if (res.commonout.code === 0) {
      res.status === 1 && this.$emit("autoDialNext");
    }
  }
  private async saveRemindCase() {
    if (this.resCalldata && timeFormat(this.nextDialTime)) {
      this.$message({
        type: "error",
        message: this.$tc("tipsLgy.NotPTPAndNextCallTime"),
      });
      this.isSaveCaseDone = false;
      return;
    }
    if (this.testSaving()) {
      const map: any = new Map(this.remindResult);
      const map1: any = new Map(this.remindResult1);
      let _arg: any = {
        Result:
          this.country == "id" && this.resCallResult == 1
            ? map1.get(this.remindResultValue)
            : map.get(this.remindResultValue), // 结果,
        Caseid: this.query.id,
        Orderid: this.ticketData.orderid,
        Phoneobject: this.phoneobject || this.reshowCaller,
        Phoneconnected: Number(this.resCallResult),
        Reasonitem: this.remindResultValue,
        Communicationway: Number(this.resRadio),
        Callid: "" + this.dialId,
        Itemid: this.itemId,
        Phonetime: this.resData,
        nextDialTime: timeFormat(this.nextDialTime), // dialer下次拨打时间
      };
      if (this.whetherPhoneReady()) {
        _arg.Phonecallinput = this.whetherPhoneReady();
      }
      if (this.resCallResult == 1) {
        _arg.Repayinclination = this.resCallMainValue;
        _arg.Phoneunconnectreason = this.resOverdueValue;
      }
      if (this.postscriptNote) {
        _arg.Remark = this.postscriptNote;
      }
      if (this.resCallMainValue == 1) {
        _arg.Promiserepayamount =
          this.resCallamount == 0 ? 0 : this.resCallamount; // 承诺还款时间
        _arg.Promiserepaytime = this.resCalldata;
      }
      let res = await saveRemindCaseApi(_arg, this);
      if (res.commonout && res.commonout.code == 0) {
        this.nextDialTime = "";
        this.$message({ type: "success", message: "save successfully" });
        this.resetSaveForm();
        this.$emit("getTableData", true);
        this.noteValueId = "";
        this.storeNameId = "";
        this.$route.query.phoneobject && this.callInfo();
        this.refreshPageType();
      }
      this.isSaveCaseDone = false;
    }
  }
  private casePageTurning(isPre: boolean) {
    let request: any = new CasePageTurningReq();
    request.setCommonin(setCommon());
    request.setCaseid(Number(this.query.id));
    request.setIspre(isPre);
    request.setOrderid(this.ticketData.orderid);
    request.setItemid(this.itemId);
    collectionServiceClient.casePageTurning(
      request,
      setMetaData(),
      (err: any, response: any) => {
        if (response) {
          const data: any = response.toObject();
          if (data.commonout.code == 0) {
            if (data.caseid && data.orderid) {
              this.$router.push({
                path: "collectionDetail",
                query: {
                  id: data.caseid,
                  type: this.query.type,
                  orderId: data.orderid,
                },
              });
              this.$router.go(0);
            } else {
              if (isPre) {
                this.$message.error(this.$tc("The first one, cannot page up"));
              } else {
                this.$message.error(this.$tc("The last one, can’t page down"));
              }
            }
          } else {
            this.$message.error(data.commonout.errmsg);
          }
        }
        if (err) {
          if (err.code == 16) {
            this.$router.push("./login");
          } else {
            this.$message.error(err.errmsg || err.message);
          }
        }
      }
    );
  }

  private updateCustomerSalaryInfo() {
    let request: any = new UpdateCustomerSalaryInfoReq();
    request.setCommonin(setCommon());
    request.setAccountid(this.customerId);
    request.setAppname(this.ticketData.appname);
    request.setSalarytype(Number(this.userSalaryType));
    if (this.userSalaryType === 1) {
      let dates: string =
        this.userSalaryDayByHalfMonth +
        "," +
        this.userSalaryDayByHalfMonthSecond;
      request.setSalaryday(dates);
    } else if (this.userSalaryType === 2) {
      request.setSalaryday(this.userSalaryDayByMonth + "");
    } else if (this.userSalaryType === 3 || this.userSalaryType === 4) {
      request.setSalaryday(this.userSalaryDayByWeek);
    }
    collectionServiceClient.updateCustomerSalaryInfo(
      request,
      setMetaData(),
      (err: any, response: any) => {
        if (response) {
          const data: any = response.toObject();
          if (data.commonout.code == 0) {
            this.$message.success("Success!");
          } else {
            this.$message.error(data.commonout.errmsg);
          }
        }
        if (err) {
          if (err.code == 16) {
            this.$router.push("./login");
          } else {
            this.$message.error(err.errmsg || err.message);
          }
        }
      }
    );
  }

  // 匹配催收方式
  private matchProviderOptions() {
    this.supplierOptions.forEach((item: any) => {
      this.suppliertypeList.forEach((s: any) => {
        if (item.id == s) {
          this.providerOptions.push(item);
        }
      });
    });
  }

  private handlePaymentLink() {
    const loading = Loading.service({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    this.paymentlinkValue = ''
    const request:any = new CreatePaymentLinkReq()
    request.setCommonin(setCommon())
    request.setCaselevel(this.caselevel)
    request.setOrderid(this.ticketData.orderid)
    request.setLang('es-CO')
    request.setAppname(this.ticketData.appname)
    collectionServiceClient.createPaymentLink(request, {}, (err: any, response: any) => {
      loading.close();
      this.paymentlinkList = response?.toObject()?.whatsappmsgmapMap
      if(response) {
        if(response?.toObject().commonout?.code === 0) {
          this.showpaymentlink = true
          this.countryCodeNew = response?.toObject().countrycode
        }else {
          this.$message.error(response?.toObject()?.commonout?.errmsg);
          this.paymentlinkValue = ''
        }
      }else {
        loading.close();
        if(err.code === 7) {
          this.$message.error(err.message);
        }else {
          this.$router.push("/login");
        }
      }
    })
  }
  private sendwa() {
    window.open(
      `https://api.whatsapp.com/send?phone=${this.countryCodeNew}${
        this.customerMobile
      }&text=${encodeURIComponent(this.paymentlinkValue) }`,
      "_blank"
    );
  }
  private created() {
    this.query = this.$route.query;
    let fullPath: string = this.$route.fullPath;
    let regex: RegExp = /type=(\w*)\&/;
    regex.test(fullPath);
    this.query.type = RegExp.$1;
    this.token = localGet("token");
    this.isfee = this.urgebase.orderdata?.ccfreduceflag;
    this.dwCommonFuc(this.urgebase);

    this.translation = this.$t;
    this.matchProviderOptions();
    this.phone = sessionStorage.getItem("phone") || ""; // lee 2021-07-16 T26887
    this.phoneobject = this.$route.query.phoneobject || "";
    let systemInfoAll: any = localStorage.getItem("systemInfoAll");
    JSON.parse(systemInfoAll);
    if (
      JSON.parse(systemInfoAll) &&
      JSON.parse(systemInfoAll).co &&
      JSON.parse(systemInfoAll).co.multi_loan_switch
    ) {
      this.multi_loan_switch = JSON.parse(systemInfoAll).co.multi_loan_switch;
    }
    this.lawyerStatusList = [
      0,
      this.$t("ticketLgy.Success"),
      this.$t("ticketLgy.Failed"),
      this.$t("lawyerLxy.LawyerStatus_UNDSend"),
      this.$t("lawyerLxy.LawyerStatus_Cancel"),
      this.$t("ticketLgy.Invalid"),
    ];
  }
  private mounted() {
    for (let i: any = 1; i <= 31; i++) {
      if (i < 10) {
        i = "0" + i;
      }
      this.salaryDaysOptions.push(i + "");
    }
    this.isShowOnepesa = window.location.href.indexOf('onepesa') != -1
  }
}
